import { useEffect } from 'react';

import { frontEndSettingsState } from '../state';
import { FrontEndSettingsState } from '../types';
import FrontEndSettingsModule, { useFrontEndSettingsQuery } from '..';
import { proxy, useSnapshot } from 'valtio';

let mockedFrontEndSettings: FrontEndSettingsState | null = null;

export function setMockedFrontEndSettings(
  settings: Partial<FrontEndSettingsState>,
) {
  mockedFrontEndSettings = proxy<FrontEndSettingsState>({
    ...frontEndSettingsState,
    ...settings,
  });
}

export function useFrontEndSettings(): FrontEndSettingsState {
  useFrontEndSettingsQuery();

  useEffect(() => {
    FrontEndSettingsModule.fetchSclSettings();
  }, []);

  const settings = mockedFrontEndSettings ?? frontEndSettingsState;

  return useSnapshot(settings);
}
